import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Official full G. R. Engineering logo as supplied by the company (never modified).
export const OFFICIAL_LOGO = "/assets/gr-official-logo.jpeg";

let cachedLogo;
export const useBranding = () => {
  const [logo, setLogo] = useState(cachedLogo || "");
  useEffect(() => {
    if (cachedLogo !== undefined) return;
    fetch(`${API}/branding`)
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => { cachedLogo = d.logo_url || ""; setLogo(cachedLogo); })
      .catch(() => { cachedLogo = ""; });
  }, []);
  return logo;
};

const BrandLogo = ({ compact = false, full = false, imgClass = "" }) => {
  const logo = useBranding();
  // Admin → Settings → Branding override always wins; otherwise the official logo is the default.
  const src = logo || (full ? OFFICIAL_LOGO : "");
  if (src) {
    const size = imgClass || (full ? "h-11 sm:h-14 lg:h-16" : compact ? "h-9" : "h-11");
    // Compact placements sit on dark backgrounds: give white-background logos a clean white surface.
    const surface = full ? "" : "bg-white rounded-sm px-1.5 py-1";
    return (
      <img
        src={src}
        alt="G. R. Engineering Private Limited"
        className={`object-contain w-auto select-none transition-all duration-300 ${size} ${surface}`}
        data-testid="brand-logo-img"
      />
    );
  }
  return (
    <span className={`bg-[#C5221F] text-white font-display font-extrabold flex items-center justify-center select-none transition-all duration-300 ${compact ? "w-9 h-9 text-sm" : "w-11 h-11 text-base"}`} data-testid="brand-logo-default">
      G.R
    </span>
  );
};

export default BrandLogo;
